import type { BillingPaymentTerm, BillingTier } from '@zeus/index'
import { useMutation } from '@apollo/client/react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { GQL_START_CHECKOUT } from '~/gql/billing/billing'
import { useResetOnPageShow } from '~/hooks/use-reset-on-page-show'
import { checkoutErrorKey } from '~/pages/backoffice/admin/billing/checkout-error'
import { goToStripe } from '~/pages/backoffice/admin/billing/stripe-redirect'

/**
 * Ouvre la page de paiement Stripe d'un palier (#352). Le palier ne change pas
 * ici : il s'active par le webhook, une fois le paiement confirmé.
 */
export function useStartCheckout() {
  const { t } = useTranslation()
  const [pendingTier, setPendingTier] = useState<BillingTier | null>(null)
  const [startCheckout] = useMutation(GQL_START_CHECKOUT)
  // Retour arrière depuis Stripe : le bouton ne reste pas « en cours ».
  useResetOnPageShow(() => setPendingTier(null))

  const start = async (tier: BillingTier, paymentTerm: BillingPaymentTerm) => {
    setPendingTier(tier)
    try {
      const { data } = await startCheckout({ variables: { input: { tier, paymentTerm } } })
      // La page quitte l'app : le bouton reste en attente jusqu'au départ.
      goToStripe(data?.startCheckout)
    } catch (error) {
      setPendingTier(null)
      toast.error(t(checkoutErrorKey(error)))
    }
  }

  return { start, pendingTier }
}
